import { getServerConfigSync, updateCachedServerConfig } from './configLoader';

// Server Configuration
// This file allows you to configure the backend server address and port

export interface ServerConfig {
  host: string;
  port: number;
  protocol: 'http' | 'https';
}

// Get default configuration from the JSON file
const defaultConfig: ServerConfig = getServerConfigSync();

// Load configuration from localStorage or use defaults
export const getServerConfig = (): ServerConfig => {
    try {
        // First try localStorage (user preferences)
        const stored = localStorage.getItem('serverConfig');
        if (stored) {
            const parsed = JSON.parse(stored);
            return {
                ...defaultConfig,
                ...parsed
            };
        }
    } catch (error) {
        console.warn('Failed to load server config from localStorage:', error);
    }
    
    return defaultConfig;
};

// Save configuration to localStorage
export const saveServerConfig = (config: ServerConfig): void => {
  try {
    localStorage.setItem('serverConfig', JSON.stringify(config));
    updateCachedServerConfig(config);
    console.log('Server configuration saved:', config);
  } catch (error) {
    console.error('Failed to save server configuration:', error);
  }
};

// Get the full server URL
export const getServerUrl = (): string => {
  const config = getServerConfig();
  return `${config.protocol}://${config.host}:${config.port}`;
};

// Reset to default configuration
export const resetServerConfig = (): void => {
  try {
    localStorage.removeItem('serverConfig');
    console.log('Server configuration reset to defaults');
  } catch (error) {
    console.error('Failed to reset server configuration:', error);
  }
};

// Validate server configuration
export const validateServerConfig = (config: ServerConfig): { valid: boolean; errors: string[] } => {
  const errors: string[] = [];
  
  if (!config.host || config.host.trim() === '') {
    errors.push('Host cannot be empty');
  }
  
  if (!config.port || config.port < 1 || config.port > 65535) {
    errors.push('Port must be between 1 and 65535');
  }
  
  if (!['http', 'https'].includes(config.protocol)) {
    errors.push('Protocol must be either http or https');
  }
  
  return {
    valid: errors.length === 0,
    errors
  };
}; 